import { GET_FAQ_ERROR, GET_FAQ_START, GET_FAQ_SUCCESS } from '../../types';

export default function get_faqs(state, action) {
  switch (action.type) {
    case GET_FAQ_START:
      return { ...state };
    case GET_FAQ_SUCCESS:
      return {
        ...state,
        data: action.results,
        error: null,
      };
    case GET_FAQ_ERROR:
      return {
        ...state,
        data: null,
        error: action.error
      };
    default:
      return { ...state };
  }
}
